import { Page } from "../../Container/page";
import { getTitles } from "../../helpers/titles";
import { parseMortalitiesData } from "../../helpers/data-parses";

export const MortalitiesPage = () => {
    return (
        <Page
            titles={getTitles("mortalities")}
            breadCrumb={
                <div className="flex text-gray-400">
                    <p>FISH MANAGEMENT / </p>&nbsp;
                    <a
                        href="/fish-management/mortalities"
                        className="hover:text-purple-600"
                    >
                        {" "}
                        MORTALITIES
                    </a>
                </div>
            }
            header={"Mortalities"}
            url={"mortalities"}
            parseData={parseMortalitiesData}
        />
    );
};
